// extracted by mini-css-extract-plugin
export var contentBody = "_b2-9";
export var headerImage = "_b2-2";
export var imageButton = "_b2-7";
export var imageButtonIcon = "_b2-8";
export var imageHeader = "_b2-4";
export var imageHeaderText = "_b2-5";
export var imageOverlay = "_b2-3";
export var imageTitle = "_b2-6";
export var imageWrapper = "_b2-1";
export var taskList = "_b2-a";
export var widget = "_b2-0";